module.exports = __webpack_public_path__ + "img/priest.d115d258.png";